import ayahPathImage from 'assets/images/phone-ayahpath.png'
import phoneImage from 'assets/images/phone-blessedpath.png'
import karmaPhoneImage from 'assets/images/phone-karmapath.png'

import { AppName } from 'root-constants'
import { TAppName } from 'root-types'

import { TImagesByApp } from './types'

export const SUBTITLE_KEY_BY_APP = {
  [AppName.blessedPath]: 'downloadApp.subtitleAndroid',
  [AppName.ayahPath]: 'downloadApp.subtitleQuran',
  [AppName.karmaPath]: 'downloadApp.subtitleKarma',
} as const satisfies Record<TAppName, string>

export const IMAGES_BY_APP = {
  [AppName.blessedPath]: phoneImage,
  [AppName.ayahPath]: ayahPathImage,
  [AppName.karmaPath]: karmaPhoneImage,
} as const satisfies TImagesByApp
